import { AxiosPromise } from 'axios';
import { ApiResponseEntity, LoginRequestDTO, LoginResponseDTO } from 'types';

import axios from 'utils/axios';

const API_PATH = '/';

export default class SecurityApi {
    static login(data: LoginRequestDTO): AxiosPromise<ApiResponseEntity<LoginResponseDTO>> {
        return axios.post(API_PATH, data);
    }
}
